<template>
  <div
    class="examine-content-item"
    v-show="isCurrentContentItem"
    v-bitmap="getListResult"
  >
    <examineList
      :examineList="examineList"
      class="examine-list-content-main"
      :examineStatus="currentStatus"
      @updateStatus="updateStatus"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import examineList from "../examine-list/examine-list.vue";

export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageNum: 1,
      examineList: null,
      getListResult: "nullData",
      testTotal: 1,
    };
  },
  components: {
    examineList,
  },
  props: {
    isCurrentContentItem: {
      type: Boolean,
    },
    currentStatus: {
      type: Number,
      require: true,
    },
    changeStatus: {
      type: Number,
    },
    searchContent: {
      type: String,
    },
  },
  watch: {
    // 切换列表显示
    isCurrentContentItem: {
      handler(val) {
        this.getExamineList();
        // if (val && !this.examineList) {
        //   this.getExamineList();
        //   // console.log('切换1');
        // }
      },
      immediate: true,
    },
    // 状态切换
    changeStatus: {
      handler(val) {
        if (val) {
          this.examineList = null;
          if (this.isCurrentContentItem) {
            // console.log('切换2');
            this.getExamineList();
          }
        }
      },
      immediate: true,
    },
    // 搜索词(监听变化，变化时重新请求数据)
    searchContent() {
      // console.log("item==>", this.searchContent);
      this.examineList = null;
      if (this.isCurrentContentItem) {
        this.getExamineList();
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取审批列表
    getExamineList() {
      // console.log(this.searchContent);
      this.post(this.$url.sensitiveWordReviewList, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolId: this.user.schoolId,
        status: this.currentStatus + "",
        // teacherId: 98,
        teacherName: this.searchContent,
      })
        .then((res) => {
          // console.log("敏感字审核列表==>", res);
          this.examineList = res.rows;
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error("获取敏感字审批列表失败！");
            return;
          }
          let data = res;
          this.total = data.total;
          this.examineList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getExamineList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getExamineList();
    },
    //
    updateStatus(e) {
      // console.log(e);
      this.$emit("updateStatus", e);
    },
    // 搜索
    // search(e) {
    //   // console.log(e);
    //   this.examineList = null;
    //   if (e == "") {
    //     this.searchContent = "";
    //     this.getExamineList();
    //   } else {
    //     this.searchContent = e;
    //     this.getExamineList();
    //   }
    // },
  },
};
</script>

<style lang="sass" scoped>
@import "./examine-content-item.scss"
</style>